module.exports = __webpack_public_path__ + "img/barFilled.eb63b5a9.svg";